import { createMayBeFor, isJust } from "@omni/utils/maybe.utils";

import { PaintConfigurationUrlState } from "@/utils/productConfiguration/visuals/paintConfiguration/paintConfigurator.types";

export const isPaintConfigurationUrlState = (
    data: any | null
): data is PaintConfigurationUrlState => {
    const maybePaintConfiguration = createMayBeFor<PaintConfigurationUrlState>(
        ["paintInfo.colorHex", "paintInfo.colorName", "paintInfo.colorId"],
        data
    );
    return isJust(maybePaintConfiguration);
};
